// extracted by mini-css-extract-plugin
export var accordion = "_b7-0";
export var chevron = "_b7-3";
export var closed = "_b7-2";
export var content = "_b7-4";
export var open = "_b7-1";
export var rotate = "_b7-5";